function AboutMe() {
  return (
    <section id="about-section" className="portfolio-section p-4 p-md-5 mb-4" aria-labelledby="about-title">
      <h2 id="about-title" className="section-title h3 mb-3">
        About Me
      </h2>
      <p className="section-text mb-3">
        I am a software developer and team lead at Lockheed Martin Space, where I work primarily with web development.
        I have a passion for programming and work on many personal projects in my free time like this website!
      </p>
      <p className="section-text mb-0">
        I enjoy building practical solutions to difficult problems and exploring new technologies through hands-on experimentation. Whether
        it's professional work or personal projects, I'm always looking for opportunities to learn and create
        meaningful software.
      </p>
    </section>
  );
}

export default AboutMe;
